import get from 'lodash/get';

import { TButtonType } from '@r1-frontend/ui-react/components/buttons/button';
import { NBSP } from '@r1-frontend/ui-kit/atoms/symbols';

import { BP42InitialState } from '~/src/packages/bp42/reducer/initialState';

export interface BP42ViewDetails {
    buttonText?: string,
    // @todo use ui-kit/button
    buttonType?: TButtonType,

    popup?: {
        title?: string,
        description?: string,
    },

    specOfferButtonText?: string,
}

const getViewDetails = (state: BP42InitialState) => {
    const { viewDetails } = state;

    return {
        buttonText: viewDetails?.buttonText || 'Заказать звонок',
        buttonType: viewDetails?.buttonType || 'action',

        popup: {
            // lodash get is used to get an empty value by path.
            // If a property is defined in the store we should not render it (like a hide title from view)
            title: get(viewDetails, 'popup.title', 'Если не хотите заполнять заявку сами'),
            description: get(viewDetails, 'popup.description', `Можно сделать это по${NBSP}телефону. Заодно поможем выбрать роутер.`),
        },

        specOfferButtonText: state.viewDetails?.specOfferButtonText || 'Продолжить онлайн',
    };
};

export default getViewDetails;
